import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import store from '@/store'

Vue.use(VueRouter)

// 路由懒加载
const Login = () => import('../views/Login.vue')
const Layout = () => import('../layout/index.vue')
const Dashboard = () => import('../views/dashboard/index.vue')
const VisitorRecord = () => import('../views/visitor/index.vue')
const AccessInformationManage = () => import('../views/accessInformation/index.vue')
const SeoManage = () => import('../views/seo/index.vue')
const NewsManage = () => import('../views/news/index.vue')
const InquiryManage = () => import('../views/inquiry/index.vue')
const SampleManage = () => import('../views/sample/index.vue')
const ProductManage = () => import('../views/product/index.vue')
const SoftwareManage = () => import('../views/software/index.vue')
const ChatbotManage = () => import('../views/chatbot/index.vue')
const AfterSaleManage = () => import('../views/aftersale/index.vue')
const EmailSettingsManage = () => import('../views/emailSettings/index.vue')
const WebSiteBasicManage = () => import('../views/website/basic/BasicView.vue')
const websiteProductManage = () => import('../views/website/product/ProductView.vue')
const wetbsitProductTypeManage = () => import('../views/website/productType/ProductType.vue')
const websiteOrdersManage = () => import('../views/website/orders/OrdersView.vue')
const websiteOrderRefundManage = () => import('../views/website/orderRefund/RefundApply.vue')

// 所有路由
export const routes = [
  {
    path: '/login',
    component: Login,
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: Dashboard,
        name: 'Dashboard',
        meta: { title: '控制台', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/visitor',
    component: Layout,
    children: [
      {
        path: 'index',
        component: VisitorRecord,
        name: 'VisitorRecord',
        meta: { title: '访客记录', icon: 'el-icon-s-custom' }
      }
    ]
  },
  {
    path: '/access-information',
    component: Layout,
    children: [
      {
        path: 'index',
        component: AccessInformationManage,
        name: 'AccessInformationManage',
        meta: { title: '访问信息', icon: 'el-icon-document-copy' }
      }
    ]
  },
  {
    path: '/seo',
    component: Layout,
    children: [
      {
        path: 'index',
        component: SeoManage,
        name: 'SeoManage',
        meta: { title: 'SEO管理', icon: 'el-icon-s-flag' }
      }
    ]
  },
  {
    path: '/news',
    component: Layout,
    children: [
      {
        path: 'index',
        component: NewsManage,
        name: 'NewsManage',
        meta: { title: '新闻管理', icon: 'el-icon-document' }
      }
    ]
  },
  {
    path: '/inquiry',
    component: Layout,
    children: [
      {
        path: 'index',
        component: InquiryManage,
        name: 'InquiryManage',
        meta: { title: '询盘管理', icon: 'el-icon-message' }
      }
    ]
  },
  {
    path: '/sample',
    component: Layout,
    children: [
      {
        path: 'index',
        component: SampleManage,
        name: 'SampleManage',
        meta: { title: '样品申请', icon: 'el-icon-s-order' }
      }
    ]
  },
  {
    path: '/product',
    component: Layout,
    children: [
      {
        path: 'index',
        component: ProductManage,
        name: 'ProductManage',
        meta: { title: '产品管理', icon: 'el-icon-s-shop' }
      }
    ]
  },
  {
    path: '/software',
    component: Layout,
    children: [
      {
        path: 'index',
        component: SoftwareManage,
        name: 'SoftwareManage',
        meta: { title: '软件管理', icon: 'el-icon-download' }
      }
    ]
  },
  {
    path: '/chatbot',
    component: Layout,
    children: [
      {
        path: 'index',
        component: ChatbotManage,
        name: 'ChatbotManage',
        meta: { title: '智能客服', icon: 'el-icon-chat-line-round' }
      }
    ]
  },
  {
    path: '/email-settings',
    component: Layout,
    children: [
      {
        path: 'index',
        component: EmailSettingsManage,
        name: 'EmailSettingsManage',
        meta: { title: '邮箱管理', icon: 'el-icon-message' }
      }
    ]
  },
  {
    path: '/aftersale',
    component: Layout,
    children: [
      {
        path: 'index',
        component: AfterSaleManage,
        name: 'AfterSaleManage',
        meta: { title: '售后管理', icon: 'el-icon-service' }
      }
    ]
  },
  {
    path: '/website',
    component: Layout,
    redirect: '/website/basic',
    meta: { title: '独立站管理', icon: 'el-icon-s-shop' },
    children: [
      {
        path: 'basic',
        component: WebSiteBasicManage,
        name: 'WebSiteBasicManage',
        meta: { title: '基础管理' }
      },
      {
        path: 'product',
        component: websiteProductManage,
        name: 'WebsiteProductManage',
        meta: { title: '产品管理' }
      },
      {
        path: 'product-type',
        component: wetbsitProductTypeManage,
        name: 'wetbsitProductTypeManage',
        meta: {title: '分类管理'}
      },
      {
        path: 'orders',
        component: websiteOrdersManage,
        name: 'websiteOrdersManage',
        meta: {title: '订单管理'}
      },
      {
        path: 'order-refund',
        component: websiteOrderRefundManage,
        name: 'websiteOrderRefundManage',
        meta: {title: '退款申请'}
      }
    ]
  },
]

const router = new VueRouter({
  routes // 使用完整的路由配置
})

// 全局路由守卫
router.beforeEach(async (to, from, next) => {
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // 登录后的跳转由登录页处理，避免守卫与登录页同时发起重定向
      next()
    } else {
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          await store.dispatch('user/getInfo')
          // 当前导航仍然有效，直接放行，避免重复导航
          next()
        } catch (error) {
          await store.dispatch('user/resetToken')
          next('/login')
        }
      }
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
